/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetAllocationCategory = {
    NET_CASH_RATIO: 'net_cash_ratio',
    NET_OTHER_RATIO: 'net_other_ratio',
    NET_NON_US_BOND_RATIO: 'net_non_us_bond_ratio',
    NET_US_BOND_RATIO: 'net_us_bond_ratio',
    NET_NON_US_EQUITY_RATIO: 'net_non_us_equity_ratio',
    NET_US_EQUITY_RATIO: 'net_us_equity_ratio',
    UNCATEGORIZED: 'uncategorized'
} as const;
export type AssetAllocationCategory = typeof AssetAllocationCategory[keyof typeof AssetAllocationCategory];


export function instanceOfAssetAllocationCategory(value: any): boolean {
    for (const key in AssetAllocationCategory) {
        if (Object.prototype.hasOwnProperty.call(AssetAllocationCategory, key)) {
            if (AssetAllocationCategory[key as keyof typeof AssetAllocationCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetAllocationCategoryFromJSON(json: any): AssetAllocationCategory {
    return AssetAllocationCategoryFromJSONTyped(json, false);
}

export function AssetAllocationCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationCategory {
    return json as AssetAllocationCategory;
}

export function AssetAllocationCategoryToJSON(value?: AssetAllocationCategory | null): any {
    return value as any;
}

export function AssetAllocationCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetAllocationCategory {
    return value as AssetAllocationCategory;
}

